// extracted by mini-css-extract-plugin
module.exports = {"plpCardSizeSelector":"PlpCardSizeSelector_plpCardSizeSelector__HU5N2","plpCardSizeSelector--singleColumn":"PlpCardSizeSelector_plpCardSizeSelector--singleColumn__R1Bxz"};